import React, {Component} from 'react'
import {noop} from 'lodash'

export class LocationAuditSearchBar extends Component {
  constructor(props) {
    super(props)
    const {name, brandName, state, city, onSearchSubmit = noop, offset, limit} = props
    this.state = {
      name,
      brandName,
      state,
      city,
      offset : 0,
      limit : 10,
    }

    this.onSubmit = event => {
      event.preventDefault()
      onSearchSubmit(this.state)
    }
    this.onFieldChange = e => this.setState({[e.target.name]: e.target.value})
  }

  render() {
    return (
      <div>
        <form onSubmit={this.onSubmit.bind(this)} className="row p-0 m-0">
          <div className="col-md-8 mb-3">
            <input className="form-control"
                    type="text"
                    id="addSearchTerm"
                    name="name"
                    defaultValue={this.state.name}
                    onChange={this.onFieldChange.bind(this)}
                    placeholder="Search Location Name: (e.g. Starbucks, Krogers)"/>
          </div>
          <div className="col-md-4 content-spacer-bottom">
            <input className="form-control"
                    type="text"
                    id="brandName"
                    name="brandName"
                    defaultValue={this.state.brandName}
                    onChange={this.onFieldChange.bind(this)}
                    placeholder="Search Chain Name"/>
          </div>
          <div className="col-md-4 content-spacer-bottom">
            <input className="form-control"
                    type="text"
                    id="city"
                    name="city"
                    defaultValue={this.state.city}
                    onChange={this.onFieldChange.bind(this)}
                    placeholder="City"/>
          </div>
          <div className="col-md-4 content-spacer-bottom">
            <input className="form-control"
                    type="text"
                    id="state"
                    name="state"
                    defaultValue={this.state.state}
                    onChange={this.onFieldChange.bind(this)}
                    placeholder="State"/>
          </div>
          <div className="col-md-4">
            <button
              type="submit"
              className="btn btn-outline-secondary w-100">
              Search
            </button>
          </div>
        </form>
      </div>
    )
  }
}
